import { MAISON_IMAGE } from "../lib/constants";
import { Reveal, MaskLine } from "./Reveal";

const VALUES = [
  ["01", "Sélection raffinée", "Chaque fragrance est choisie pour son sillage et sa tenue."],
  ["02", "Conseils personnalisés", "Une écoute attentive pour trouver votre signature."],
  ["03", "Expérience boutique", "Un rituel d'emballage soigné, pensé comme un cadeau."],
];

export const Maison = () => (
  <section id="maison" className="border-y border-espresso/10 bg-cream py-24 sm:py-32">
    <div className="wrap grid items-center gap-14 lg:grid-cols-2">
      <Reveal className="relative">
        <div aria-hidden className="absolute -bottom-4 -right-4 h-full w-full rounded-2xl border border-champagne/40" />
        <img
          src={MAISON_IMAGE}
          alt="L'univers Vāsam"
          loading="lazy"
          className="relative aspect-[4/3] w-full rounded-2xl object-cover"
        />
      </Reveal>

      <div>
        <Reveal>
          <p className="eyebrow flex items-center gap-4 text-champagne">
            <span className="h-px w-10 bg-champagne" />
            La Maison
          </p>
        </Reveal>
        <MaskLine className="mt-5">
          <h2 className="font-serif text-4xl leading-[1.05] text-espresso sm:text-5xl">
            Une maison de fragrances,
            <br />
            <em className="italic text-taupe">une signature</em>
          </h2>
        </MaskLine>

        <Reveal delay={0.15}>
          <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-espresso/75">
            Vāsam est née d'une conviction : le parfum est la signature invisible que l'on laisse derrière soi.
          </p>
          <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-espresso/75">
            Carine, fondatrice de Vāsam et consultante Chogan indépendante, a réuni une sélection d'extraits de
            parfum d'exception — concentrés à 30 %, au rapport qualité-prix rare — pour que le luxe du sillage soit
            accessible à toutes et à tous.
          </p>
        </Reveal>

        <div className="mt-10">
          {VALUES.map(([num, title, text], i) => (
            <Reveal key={num} delay={0.1 + i * 0.08}>
              <div className="flex items-start gap-6 border-t border-espresso/10 py-5">
                <span className="font-serif text-lg italic text-champagne">{num}</span>
                <div>
                  <h3 className="font-serif text-2xl text-espresso">{title}</h3>
                  <p className="mt-1 text-sm text-espresso/65">{text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-6 border-l-2 border-champagne/50 pl-4 text-[11px] leading-relaxed text-taupe">
            Produits du groupe Chogan — expédiés de manière sécurisée, fiable et suivie.
            <br />
            Distribution indépendante des parfums Chogan.
          </p>
        </Reveal>

        <Reveal delay={0.35}>
          <p className="mt-8 font-serif text-3xl italic text-espresso">Carine</p>
          <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-taupe">Fondatrice de Vāsam · Consultante Chogan</p>
        </Reveal>
      </div>
    </div>
  </section>
);
